import { render } from "./selected.vue?vue&type=template&id=6d794b88"
import script from "./selected.vue?vue&type=script&lang=js"
export * from "./selected.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__